import { render, staticRenderFns } from "./viewFolder.vue?vue&type=template&id=ca3b7528&scoped=true"
import script from "./viewFolder.vue?vue&type=script&lang=js"
export * from "./viewFolder.vue?vue&type=script&lang=js"
import style0 from "./viewFolder.vue?vue&type=style&index=0&id=ca3b7528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b7528",
  null
  
)

export default component.exports